import React from "react"
import { ExternalLink } from "components"
import styles from "./panelist.module.scss"

const Panelist = ({ content }) => {
  return (
    <div className={styles.panelist}>
      <div className={styles.panelistProfile}>
        {content.img && (
          <div className={styles.panelistPhoto}>
            <img src={content.img.url} alt={content.name} />
          </div>
        )}
        <h4 className={styles.panelistName}>
          {content.url ? (
            <ExternalLink url={content.url}>{content.name}</ExternalLink>
          ) : (
            content.name
          )}
        </h4>
      </div>
      <div className={styles.panelistBio}>{content.bio}</div>
      {content.url && (
        <ExternalLink className={styles.panelistBioLink} url={content.url}>
          Read bio
        </ExternalLink>
      )}
    </div>
  )
}

export default Panelist
